import React, { useEffect } from "react";
import ExtensionInputGroup, { StyledLabel, StyledToggleLabel } from "./ExtensionInputGroup";
import styled from "styled-components";
import {
    DEAL_CANCELLED,
    DEAL_LOST,
    DEAL_WON,
    dealChannelTypesOptions,
    dealMarketingTypesOptions,
} from "../utils/constants";
import { StyledItemContainer } from "./ExtensionViewDeal";
import Toggle from "app/popleads/components/ui-kit/Toggle";
import ExtensionCampaignSearchInput from "./ExtensionCampaignSearchInput";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import useCompanyData from "app/popleads/hooks/useCompanyData";
import useGetCompanyConfigByKeys from "app/popleads/hooks/useGetCompanyConfigByKeys";
import ExtensionDealAttachments from "./ExtensionDealAttachments";
import { isCipdCampaign } from "../utils/constants";
import { useExtensionContext } from "../ExtensionContext";
import { ExtensionSmall } from "app/popleads/components/ui-kit/Text";

const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

const options = [
    { label: "Yes", value: "Yes", activeVariant: "success" },
    { label: "No", value: "No", activeVariant: "neutral" },
];
const membershipOptions = [
    { label: "Student", value: "Student" },
    { label: "Center", value: "Center" },
];

const ExtensionNewPublicDeal = ({ dealObject, setDealObject, validateField }) => {
    const { companyUsers } = useCompanyData();
    const { cvAttachment, setCvAttachment } = useExtensionContext();
    const handleInputChange = (field, value) => {
        //if (validateField(field, value)) {
        setDealObject((prevState) => ({ ...prevState, [field]: value }));
        //}
    };
    const { checkCertificateNameCondition } = useGetCompanyConfigByKeys();
    const certificateInputShow = checkCertificateNameCondition(dealObject.dealCampaignType);
    const isCipdDeal = isCipdCampaign(dealObject.campaign);
    const showMembership = isCipdDeal && dealObject.status === DEAL_WON;
    useEffect(() => {
        if (!showMembership && dealObject.membership) {
            handleInputChange("membership", "");
        }
    }, [showMembership, dealObject.membership]);
    return (
        <StyledContainer>
            <ExtensionCampaignSearchInput
                optionClick={(value) => {
                    handleInputChange("campaign", value);
                    if (!isCipdCampaign(value) || dealObject.status !== DEAL_WON) {
                        handleInputChange("membership", "");
                    }
                    if (dealObject.dealCampaignType === "Public-ExEd" && value?.fullPrice) {
                        handleInputChange("amount", value.fullPrice);
                    }
                }}
                value={dealObject.campaign}
                label="Campaign Name"
                isClearable={true}
            />
            <ExtensionInputGroup
                label="Unit Amount USD"
                type="input"
                inpType="number"
                min={0}
                leftIcon="dollar-sign"
                onChange={(e) => {
                    const value = e.target ? e.target.value : e;
                    handleInputChange("amount", value);
                }}
                value={dealObject.amount}
                minLength={1}
                placeholder="Please enter unit amount"
                variant="l3rnTech"
            />
            {(dealObject.status === DEAL_WON ||
                dealObject.status === DEAL_LOST ||
                dealObject.status === DEAL_CANCELLED) && (
                <div>
                    <StyledLabel>Number of Units</StyledLabel>
                    <div style={{ display: "flex", gap: "16px", marginTop: "4px" }}>
                        <ButtonWithText
                            label="Decrease"
                            icon="remove"
                            onClick={() => {
                                const currentValue = Number(dealObject.numberOfUnits) || 1;
                                if (currentValue > 1) {
                                    handleInputChange("numberOfUnits", currentValue - 1);
                                }
                            }}
                            iconType="material"
                            variant={dealObject.numberOfUnits === 1 ? "passive" : "l3rnTech"}
                            buttonStyle="default"
                            size="circle"
                        />
                        {dealObject.numberOfUnits}
                        <ButtonWithText
                            label="Increase"
                            icon="add"
                            onClick={() => {
                                const currentValue = Number(dealObject.numberOfUnits) || 0;
                                handleInputChange("numberOfUnits", currentValue + 1);
                            }}
                            iconType="material"
                            variant="l3rnTech"
                            buttonStyle="default"
                            size="circle"
                        />
                    </div>
                </div>
            )}
            {companyUsers.length > 0 && (
                <ExtensionInputGroup
                    label="Partner"
                    type="select"
                    loadOptions={(input, callback) => {
                        callback(
                            companyUsers
                                .filter((user) => user.name.toLowerCase().includes(input.toLowerCase()))
                                .map((item) => {
                                    return {
                                        label: item.name,
                                        value: item.id,
                                    };
                                })
                                .slice(0, 10)
                        );
                    }}
                    onChange={(selected) => {
                        if (selected) {
                            setDealObject({ ...dealObject, partnerName: selected.label, partner: selected.value });
                        } else {
                            setDealObject({ ...dealObject, partnerName: "", partner: "" });
                        }
                    }}
                    defaultOptions={true}
                    value={
                        dealObject?.partnerName
                            ? {
                                  label: dealObject?.partnerName,
                                  value: dealObject?.partner,
                              }
                            : ""
                    }
                    placeholder="Please select partner"
                    isClearable={true}
                    variant="l3rnTech"
                />
            )}
            {dealObject.dealCampaignType === "L&D Broker" && (
                <>
                    <ExtensionInputGroup
                        label="Amount for Vendor Payment"
                        type="input"
                        inpType="number"
                        leftIcon="dollar-sign"
                        onKeyDown={(e) => {
                            if (e.key === "-" || e.key === "e" || e.key === "+") {
                                e.preventDefault();
                            }
                        }}
                        onChange={(e) => {
                            const value = e.target ? e.target.value : e;
                            handleInputChange("vendorPaymentAmount", value);
                        }}
                        value={dealObject.vendorPaymentAmount}
                        minLength={1}
                        placeholder="Enter amount for vendor payment"
                        variant="l3rnTech"
                    />
                    <ExtensionInputGroup
                        label="Margin amount for LEORON"
                        type="input"
                        inpType="number"
                        leftIcon="dollar-sign"
                        onKeyDown={(e) => {
                            if (e.key === "-" || e.key === "e" || e.key === "+") {
                                e.preventDefault();
                            }
                        }}
                        onChange={(e) => {
                            const value = e.target ? e.target.value : e;
                            handleInputChange("leoronMarginAmount", value);
                        }}
                        value={dealObject.leoronMarginAmount}
                        minLength={1}
                        placeholder="Enter margin amount for LEORON"
                        variant="l3rnTech"
                    />
                </>
            )}

            {dealObject.status === DEAL_WON && (
                <>
                    <ExtensionInputGroup
                        label="Closing Date"
                        type="date"
                        onChange={(date) => {
                            handleInputChange("closingDate", date);
                        }}
                        value={dealObject.closingDate}
                        placeholder="Please select closing date"
                        dateFormat="dd/MM/yyyy"
                        variant="l3rnTech"
                    />
                    <ExtensionInputGroup
                        label="Type"
                        type="select"
                        options={dealMarketingTypesOptions}
                        value={dealObject.type ? { label: dealObject.type, value: dealObject.type } : ""}
                        onChange={(selected) => {
                            handleInputChange("type", selected.value);
                        }}
                        placeholder="Please select type"
                        variant="l3rnTech"
                    />
                    {(dealObject.type === "Marketing" || dealObject.type === "Marketing Cross Sale") && (
                        <ExtensionInputGroup
                            label="Marketing Channel"
                            type="select"
                            options={dealChannelTypesOptions}
                            value={
                                dealObject.channelType
                                    ? { label: dealObject.channelType, value: dealObject.channelType }
                                    : ""
                            }
                            onChange={(selected) => {
                                handleInputChange("channelType", selected.value);
                            }}
                            placeholder="Please select marketing channel"
                            variant="l3rnTech"
                        />
                    )}
                    {dealObject.type === "Re-Seller Partnership" && (
                        <ExtensionInputGroup
                            label="End User"
                            type="input"
                            inpType="text"
                            onChange={(e) => {
                                const value = e.target ? e.target.value : e;
                                handleInputChange("endUser", value);
                            }}
                            value={dealObject.endUser}
                            placeholder="Please enter end user"
                            minLength={1}
                            variant="l3rnTech"
                        />
                    )}
                    <ExtensionInputGroup
                        label="Paid Amount"
                        type="input"
                        inpType="number"
                        leftIcon="dollar-sign"
                        onKeyDown={(e) => {
                            if (e.key === "-" || e.key === "e" || e.key === "+") {
                                e.preventDefault();
                            }
                        }}
                        onChange={(e) => {
                            const value = e.target ? e.target.value : e;
                            handleInputChange("paidAmount", value);
                        }}
                        value={dealObject.paidAmount}
                        minLength={1}
                        placeholder="Please enter paid amount"
                        disabled={dealObject?.createAnotherDeal || dealObject?.toBe === DEAL_WON}
                        variant="l3rnTech"
                    />
                    {certificateInputShow && (
                        <>
                            <ExtensionInputGroup
                                label="Certificate Name"
                                type="input"
                                inpType="text"
                                onChange={(e) => {
                                    const value = e.target ? e.target.value : e;
                                    if (value.trim() === "") {
                                        validateField("certificateName", "Certificate name cannot be empty");
                                    }
                                    handleInputChange("certificateName", value);
                                }}
                                value={dealObject.certificateName}
                                placeholder="Please enter certificate name"
                                minLength={1}
                                variant="l3rnTech"
                            />
                            <ExtensionInputGroup
                                label="Certificate Lastname"
                                type="input"
                                inpType="text"
                                onChange={(e) => {
                                    const value = e.target ? e.target.value : e;
                                    if (value.trim() === "") {
                                        validateField("certificateLastName", "Certificate lastname cannot be empty");
                                    }
                                    handleInputChange("certificateLastName", value);
                                }}
                                value={dealObject.certificateSurname}
                                placeholder="Please enter certificate lastname"
                                minLength={1}
                                variant="l3rnTech"
                            />
                        </>
                    )}

                    <StyledItemContainer>
                        <StyledToggleLabel>Vat Included</StyledToggleLabel>
                        <Toggle
                            size="small"
                            setSelected={(value) => {
                                handleInputChange("vatIncludes", value);
                            }}
                            selected={dealObject.vatIncludes}
                            options={options}
                            variant="l3rnTech"
                        />
                    </StyledItemContainer>
                    <StyledItemContainer>
                        <StyledToggleLabel>Self Investment</StyledToggleLabel>
                        <Toggle
                            size="small"
                            setSelected={(value) => {
                                handleInputChange("isSelfInvestment", value);
                                if (value !== "Yes") {
                                    handleInputChange("numberOfInstallments", "");
                                }
                            }}
                            selected={dealObject.isSelfInvestment}
                            options={options}
                            variant="l3rnTech"
                        />
                    </StyledItemContainer>
                    {showMembership && (
                        <ExtensionInputGroup
                            label="Membership"
                            type="select"
                            options={membershipOptions}
                            value={
                                dealObject.membership
                                    ? { label: dealObject.membership, value: dealObject.membership }
                                    : ""
                            }
                            onChange={(selected) => handleInputChange("membership", selected?.value || "")}
                            placeholder="Select Membership"
                            required={true}
                            variant="l3rnTech"
                        />
                    )}
                    <ExtensionInputGroup
                        label="National ID Number"
                        type="input"
                        inpType="text"
                        onChange={(value) => {
                            handleInputChange("nationalIdNumber", value);
                        }}
                        value={dealObject.nationalIdNumber || ""}
                        placeholder="Please enter national ID number"
                        minLength={1}
                        maxLength={99}
                        required={dealObject.isSelfInvestment === "Yes"}
                        variant="l3rnTech"
                    />
                    {isCipdDeal && dealObject.isSelfInvestment === "Yes" && (
                        <ExtensionInputGroup
                            label="Number of Installments"
                            type="input"
                            // type="number" inputs ignore the maxlength attribute in every
                            // browser, so the cap below relied entirely on the onChange
                            // slice - "text" makes maxLength an actual DOM-enforced limit
                            // too (same pattern as National ID Number). inputMode/pattern
                            // keep the numeric-only intent (numeric mobile keypad, digit
                            // validation hint) without reintroducing type="number"'s bug.
                            inpType="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            min={1}
                            maxLength={7}
                            debounceTime={0}
                            // The underlying input is a DebounceInput that (while focused)
                            // does not let an incoming `value` prop override what the user
                            // just typed, so filtering only in onChange left invalid
                            // characters visible on screen even though state was already
                            // corrected underneath. Block non-digit keystrokes and pasted
                            // text before they ever reach the input's value at all.
                            onKeyDown={(e) => {
                                if (e.ctrlKey || e.metaKey || e.key.length > 1) return; // Backspace, Tab, arrows, Ctrl+V, ...
                                if (!/^[0-9]$/.test(e.key)) e.preventDefault();
                            }}
                            onPaste={(e) => {
                                e.preventDefault();
                                const pasted = (e.clipboardData || window.clipboardData)
                                    .getData("text")
                                    .replace(/[^0-9]/g, "")
                                    .slice(0, 7);
                                handleInputChange("numberOfInstallments", pasted);
                            }}
                            onChange={(e) => {
                                const value = e.target ? e.target.value : e;
                                const positiveInteger = value.replace(/[^0-9]/g, "").slice(0, 7);
                                handleInputChange("numberOfInstallments", positiveInteger);
                            }}
                            value={dealObject.numberOfInstallments || ""}
                            placeholder="Please enter number of installments"
                            required={true}
                            variant="l3rnTech"
                        />
                    )}
                    {isCipdDeal && (
                        <>
                            <ExtensionInputGroup
                                label="Date of Birth"
                                type="date"
                                onChange={(date) => {
                                    handleInputChange("dateOfBirth", date);
                                }}
                                value={dealObject.dateOfBirth}
                                placeholder="Please select date of birth"
                                dateFormat="dd/MM/yyyy"
                                required={true}
                                variant="l3rnTech"
                            />
                            <ExtensionInputGroup
                                label="Physical Address"
                                type="textarea"
                                onChange={(e) => {
                                    const value = e.target ? e.target.value : e;
                                    handleInputChange("physicalAddress", value);
                                }}
                                value={dealObject.physicalAddress || ""}
                                placeholder="Please enter physical address"
                                required={true}
                                variant="l3rnTech"
                            />
                            <div>
                                <StyledLabel required={true}>CV Attachment</StyledLabel>
                                <ExtensionDealAttachments
                                    maxFiles={1}
                                    onFilesChange={setCvAttachment}
                                    existingFiles={[]}
                                    isCvAttachment={true}
                                />
                                {!cvAttachment?.length && (
                                    <ExtensionSmall style={{ color: "#ff4d4f" }}>
                                        CV attachment is required for CIPD deals
                                    </ExtensionSmall>
                                )}
                            </div>
                        </>
                    )}
                    <div>
                        <StyledLabel>Upload Document</StyledLabel>
                        <ExtensionDealAttachments maxFiles={5} />
                    </div>
                </>
            )}
            {(dealObject.status === "Lost" || dealObject.status === "Cancelled") && (
                <>
                    <ExtensionInputGroup
                        label="Closing Date"
                        type="date"
                        onChange={(date) => {
                            handleInputChange("closingDate", date);
                        }}
                        value={dealObject.closingDate}
                        placeholder="Please select closing date"
                        dateFormat="dd/MM/yyyy"
                        variant="l3rnTech"
                    />
                    <ExtensionInputGroup
                        label="Type"
                        type="select"
                        options={dealMarketingTypesOptions}
                        value={dealObject.type ? { label: dealObject.type, value: dealObject.type } : ""}
                        onChange={(selected) => {
                            handleInputChange("type", selected.value);
                        }}
                        placeholder="Please select type"
                        variant="l3rnTech"
                    />
                    {(dealObject.type === "Marketing" || dealObject.type === "Marketing Cross Sale") && (
                        <ExtensionInputGroup
                            label="Marketing Channel"
                            type="select"
                            options={dealChannelTypesOptions}
                            value={
                                dealObject.channelType
                                    ? { label: dealObject.channelType, value: dealObject.channelType }
                                    : ""
                            }
                            onChange={(selected) => {
                                handleInputChange("channelType", selected.value);
                            }}
                            placeholder="Please select marketing channel"
                            variant="l3rnTech"
                        />
                    )}
                    {dealObject.type === "Re-Seller Partnership" && (
                        <ExtensionInputGroup
                            label="End User"
                            type="input"
                            inpType="text"
                            onChange={(e) => {
                                const value = e.target ? e.target.value : e;
                                handleInputChange("endUser", value);
                            }}
                            value={dealObject.endUser}
                            placeholder="Please enter end user"
                            minLength={1}
                            variant="l3rnTech"
                        />
                    )}
                </>
            )}
        </StyledContainer>
    );
};

export default ExtensionNewPublicDeal;
